import React, { useState } from "react";
import { Link, useLocation, Outlet, useNavigate } from "react-router-dom";
import {
  Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText,
  AppBar, Toolbar, IconButton, Typography, CssBaseline, useMediaQuery, Button
} from "@mui/material";
import { Storefront, Menu, Assignment, Logout as LogoutIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const drawerWidth = 200;

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [isOpen, setIsOpen] = useState(!isMobile);
  const toggleSidebar = () => setIsOpen(!isOpen);

  const menuItems = [
    { path: "user", name: "User", icon: <Storefront /> },
    { path: "user-tasks", name: "User Tasks", icon: <Assignment /> },
  ];

  // Handle Logout Function
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user'); // Example: Clearing user token
    navigate("/login"); // Redirect to login page
  };

  return (
    <div className="flex min-h-screen">
      <CssBaseline />

      {/* Top Navbar */}
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "#d32f2f" }}>
        <Toolbar>
          {/* Sidebar Toggle Button */}
          <IconButton edge="start" sx={{ color: "white" }} onClick={toggleSidebar}>
            <Menu />
          </IconButton>
          
          <Typography variant="h6" sx={{ flexGrow: 1, color: "white" }}>
            Dashboard
          </Typography>

          {/* Logout Button */}
          <Button
            variant="outlined"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
            sx={{
              color: "white",
              borderColor: "white",
              textTransform: "none",
              fontWeight: "bold",
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "white",
                color: "#d32f2f",
              },
            }}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      {/* Sidebar Drawer */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isOpen}
        onClose={toggleSidebar}
        sx={{
          width: isOpen ? drawerWidth : 0,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: isOpen ? drawerWidth : 60,
            transition: "width 0.3s ease",
          },
        }}
      >
        <Toolbar />
        <List>
          {menuItems.map(({ path, name, icon }) => (
            <ListItem key={path} disablePadding>
              <ListItemButton
                component={Link}
                to={path}
                selected={location.pathname === `/${path}`}
                sx={{
                  "&.Mui-selected": { bgcolor: "primary.main", color: "white" },
                  "&:hover": { bgcolor: "primary.light", color: "black" },
                }}
              >
                <ListItemIcon sx={{ color: "inherit" }}>{icon}</ListItemIcon>
                {isOpen && <ListItemText primary={name} />}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </div>
  );
};

export default Sidebar;
